export default __webpack_public_path__ + "static/media/closet5-before3-1024w.9e5e7a99.png";